var _circle, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlageTunDestination(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 110,
    viewBox: "0 0 110 110",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 55,
    r: 55,
    fill: "#F1F1FF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7644_78213",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 8,
    width: 94,
    height: 94
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.9999 101.168C80.4977 101.168 101.168 80.4982 101.168 55.0004C101.168 29.5026 80.4977 8.83252 54.9999 8.83252C29.5021 8.83252 8.83203 29.5026 8.83203 55.0004C8.83203 80.4982 29.5021 101.168 54.9999 101.168Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7644_78213)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.0022 101.17C80.5013 101.17 101.172 80.4994 101.172 55.0003C101.172 29.5012 80.5013 8.83008 55.0022 8.83008C29.5031 8.83008 8.83203 29.5012 8.83203 55.0003C8.83203 80.4994 29.5031 101.17 55.0022 101.17Z",
    fill: "#CE1A17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0006 80.6893C69.1904 80.6893 80.6907 69.1889 80.6907 54.9992C80.6907 40.8094 69.1904 29.3091 55.0006 29.3091C40.8109 29.3091 29.3105 40.8094 29.3105 54.9992C29.3105 69.1889 40.8109 80.6893 55.0006 80.6893ZM61.8906 59.4815L56.9857 66.3202L56.9472 57.9063L48.9303 55.345L56.9216 52.7068L56.8832 44.2928L61.865 51.0803L69.8563 48.4422L64.9514 55.2809L69.9332 62.0684L61.8906 59.4815ZM55.2055 35.8148C60.7892 35.8148 65.835 38.1713 69.3825 41.9364C66.9236 40.374 64.0165 39.4647 60.8917 39.4647C52.1448 39.4647 45.0499 46.5596 45.0499 55.3065C45.0499 64.0535 52.1448 71.1483 60.8917 71.1483C64.0165 71.1483 66.9364 70.2391 69.3825 68.6766C65.8222 72.4418 60.7892 74.7982 55.2055 74.7982C44.4352 74.7982 35.7139 66.0641 35.7139 55.3065C35.7139 44.5362 44.4352 35.8148 55.2055 35.8148Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.9223 55.2678L69.8273 48.429L61.8359 51.0672L56.8542 44.2925L56.8926 52.7064L48.9141 55.3446L56.931 57.9059L56.9694 66.3199L61.8872 59.4811L69.9041 62.0425L64.9223 55.2678Z",
    fill: "#CE1A17"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.2046 74.7983C60.7883 74.7983 65.8341 72.4419 69.3815 68.6767C66.9226 70.2392 64.0155 71.1484 60.8907 71.1484C52.1438 71.1484 45.0489 64.0536 45.0489 55.3066C45.0489 46.5597 52.1438 39.4648 60.8907 39.4648C64.0155 39.4648 66.9354 40.3741 69.3815 41.9365C65.8213 38.1714 60.7883 35.8149 55.2046 35.8149C44.4342 35.8149 35.7129 44.5363 35.7129 55.3066C35.7129 66.0642 44.4342 74.7983 55.2046 74.7983Z",
    fill: "#CE1A17"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlageTunDestination);
export default __webpack_public_path__ + "static/media/flageTUNDestination.9ff0b55a76d8543ac80b10d1151dd789.svg";
export { ForwardRef as ReactComponent };